"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramSerializer = void 0;
function paramSerializer(params) {
    if (params === void 0) { params = {}; }
    var queryParams = Object.entries(params);
    var queryString = '';
    if (queryParams.length > 0) {
        queryString = "?" + new URLSearchParams(queryParams);
    }
    return queryString;
}
exports.paramSerializer = paramSerializer;
//# sourceMappingURL=index.js.map